var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#F1F0F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_28226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 136,
    height: 136
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#EFF4FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_28226)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_276_28226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.773 66.1472L124.568 66.0246V65.8067H124.193L80.4483 28.4608C77.0758 25.5817 72.7869 24 68.3527 24C63.9729 24 59.7332 25.5431 56.3781 28.3584L11.749 65.8067H11.3746V66.0246L11.1692 66.1472H11.3746L11.0414 130.959C11.0185 135.393 14.6069 139 19.0412 139H116.234C120.637 139 124.212 135.443 124.234 131.041L124.568 66.1472H124.773Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109 44.4314V80.0383L90.9907 90.836L85.6262 94.0496L74.2586 100.991L68.8941 104.205L66.595 105.619L64.5514 104.205L59.4424 100.991L48.7134 94.1781L43.6044 90.9645L27 80.4239V44.4314C27 40.7037 30.0654 37.6186 33.7695 37.6186H102.358C106.062 37.6186 109 40.7037 109 44.4314Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5653 107.326C62.7619 106.038 54.8454 99.7154 51.5474 91.4587C47.7638 82.0446 52.7971 76.8891 56.9189 76.3993C59.7184 76.1066 62.8342 78.3196 63.0324 81.2787C63.3497 86.5707 54.0926 89.5849 48.5426 83.7031C46.5053 81.5317 45.4428 78.4056 45.7691 75.5239C46.2571 70.6256 50.1558 66.8067 53.8775 63.668C54.7218 62.9817 55.5661 62.2955 56.4818 61.5675C58.5273 59.9862 61.0307 58.0408 63.8615 56",
    stroke: "#B1AED3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.844 66.0083L124.983 130.458C124.992 134.883 121.408 138.475 116.983 138.475H19.1384C14.7268 138.475 11.1479 134.904 11.1384 130.492L11 66.0083H11.1555L65.0561 97.7657H70.7883L124.689 66.0083H124.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M65.2519 98.3891H70.9278L124.452 138.475H11.728L65.2519 98.3891Z",
    fill: "#EEF1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3898 51.9884L69.0195 54.5393C68.0303 54.9644 67.041 54.2558 67.041 53.1221L68.0303 42.3519",
    fill: "#B1AED3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_276_28226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.711 35.9747L120.178 37.9587L83.1519 58.9324C81.456 59.9244 79.3362 59.3576 78.2056 57.7987L69.7262 45.1862L68.0303 42.6353L63.3667 35.5496C62.3774 33.9907 63.508 31.865 65.3452 32.0067L117.069 35.6913L123.711 35.9747Z",
    fill: "url(#paint0_radial_276_28226)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.711 35.9747L120.178 37.9587L70 45.5L68.0298 42.4936L116.5 35.9747L123.711 35.9747Z",
    fill: "#B1AED3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_276_28226",
    x: -58.959,
    y: -47,
    width: 253.732,
    height: 255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.170527 0 0 0 0 0.504167 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_28226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_28226",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_276_28226",
    x: 55,
    y: 29,
    width: 76.7114,
    height: 43.4259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.861111 0 0 0 0 0.854167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_28226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_28226",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_276_28226",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.9463 57.8808) rotate(-24.5095) scale(62.3868 52.4978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737098"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.a66e6a62ad22171a8da76061268fb2a4.svg";
export { ForwardRef as ReactComponent };